module.exports = __webpack_public_path__ + "img/diamonds.69eb0c76.png";